// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__Fpg7C","file":"styles_file__1VbRv"};